import { useEffect } from 'react';
import { trackOnPageExitIntent } from 'FormsUI/utils/TrackingUtils';
const PageStatusChangeTrackingWrapper = ({
  children
}) => {
  useEffect(() => {
    window.addEventListener('pagehide', trackOnPageExitIntent);
    return () => {
      window.removeEventListener('pagehide', trackOnPageExitIntent);
    };
  }, []);
  return children;
};
export default PageStatusChangeTrackingWrapper;